<template>
  <div class="pt-8 pb-6 flex flex-col" style="gap: 1rem" v-if="setting">
    <div class="plusTextPrimary--text" style="font-size: 1.25rem">
      {{ $t('message.' + titleKey) }}
    </div>
    <div class="plusTextSecondary--text" style="font-size: 0.875rem">
      {{ $t('message.' + titleKey + '_explained') }}
    </div>
    <v-switch color="plusIndigoLighten1" inset :label="$t('message.active')" :hide-details="true" class="pt-0 mt-0"
      :input-value="setting.active" @change="$emit('update:active', $event ? true : false)"></v-switch>
    <span class="plusTextPrimary--text">{{ $t('message.alternative_emails') }}:</span>
    <div v-if="setting.emails && setting.emails.length">
      <template v-for="(i, index) in setting.emails">
        <v-chip close @click:close="$emit('remove-email', i)" :key="'alt_automation_email' + index" v-if="i && i != ''"
          small class="ma-1 plusDeepPurpleLighten5 plusTextPrimary--text font-weight-regular"
          style="font-size: 0.875rem">{{ i }}</v-chip>
      </template>
    </div>
    <div class="flex items-center" style="gap: 1.25rem">
      <v-text-field :hide-details="true" outlined dense :label="$t('message.add_alternative_email')"
        v-model="newEmail"></v-text-field>
      <v-btn @click="addEmail()">
        {{ $t('message.academy_settings_admin_plus.add_email') }}
      </v-btn>
    </div>
    <!--Only the emails the member reads take a template. On the ones that go to
    the academy a template would replace the member, the reason and the link to
    the transaction with copy that has no way to reference any of them.-->
    <div style="max-width: 15.5rem" v-if="withTemplate">
      <v-select item-text="name" item-value="_id" outlined dense :clearable="true" :value="setting.template"
        @change="$emit('update:template', $event)" :placeholder="$t('message.select_email_template')"
        :items="emailTemplates">
      </v-select>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newEmail: null,
    };
  },
  props: {
    //The automatedEmails entry this section edits. Read only here - every
    //change goes back to AcademySettings.vue as an event, which is what keeps
    //the whole object in one place for the save.
    setting: {
      type: Object,
      default: null,
    },
    //Both the heading and the line under it come from this, so a new section
    //needs the pair <key> and <key>_explained.
    titleKey: {
      type: String,
      default: '',
    },
    withTemplate: {
      type: Boolean,
      default: false,
    },
    emailTemplates: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    addEmail() {
      const email = this.newEmail ? this.newEmail.trim().toLowerCase() : null;
      if (!this.isValidEmail(email)) {
        this.showAlert('error', this.$t('message.invalid_email'));
        return;
      }
      const existing = this.setting.emails ? this.setting.emails : [];
      if (existing.indexOf(email) >= 0) {
        this.showAlert('error', this.$t('message.duplicate'));
        return;
      }
      this.$emit('add-email', email);
      this.newEmail = null;
    },
  },
};
</script>

<style scoped></style>
